import { Picture, Source } from "~/components/ui/Picture"
import type { ImageWidget } from "~/types/widgets"
import { isSchedulingActive, type Scheduling } from "~/sdk/contentScheduling"

export interface Image {
    /**
     * @title Imagem
     */
    image: ImageWidget

    /**
     * @title Largura (em px)
     */
    width?: number

    /**
     * @title Altura (em px)
     */
    height?: number
}

export interface Props {
    desktop: Image
    mobile: Image
    /**
     * @title Texto alternativo
     */
    alt?: string
    /**
     * @title LCP - Marque se essa é a maior imagem da página
     */
    lcp?: boolean
    /**
     * @title Agendamento
     * @description Deixe este campo vazio para manter sempre visível
     */
    scheduling?: Scheduling
}

export default function Banner({ desktop, mobile, alt, scheduling, lcp }: Props) {
    if (!isSchedulingActive(scheduling)) return null

    return (
        <Picture preload={lcp} className='block'>
            <Source
                src={mobile.image}
                media='(max-width: 767px)'
                width={mobile.width ?? 370}
                height={mobile.height ?? 130}
                fetchPriority='high'
            />

            <Source
                src={desktop.image}
                media='(min-width: 768px)'
                width={desktop.width ?? 1920}
                height={desktop.height ?? 200}
                fetchPriority='high'
            />

            <img
                className='mx-auto lg:w-full'
                src={mobile.image}
                alt={alt}
                loading={lcp ? 'eager' : 'lazy'}
            />
        </Picture>
    )
}
